import { PresenceStatus, type User } from "../core/types";

export const sortUsersByAvatar = (users: User[]): User[] => {
  const withAvatar = users.filter(user => !!user.avatar_url);
  const withoutAvatar = users.filter(user => !user.avatar_url);
  return [...withAvatar, ...withoutAvatar];
};

export const getActiveSupportAgents = (users: User[]): User[] => {
  const withOnline = users.filter(user => user.presence_status === PresenceStatus.ONLINE);
  const withOnBreak = users.filter(user => user.presence_status === PresenceStatus.ON_BREAK);
  return sortUsersByAvatar([...withOnline, ...withOnBreak]);
};
